import { useState, useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import type { ActivityFeedItem } from '@/types'
import { DUMMY_ACTIVITY } from '@/lib/dummyData'

export function useActivityFeed(limit = 6) {
  const [items, setItems] = useState<ActivityFeedItem[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase
      .from('activity_feed')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit)
      .then(({ data, error }) => {
        const rows = !error && data && data.length > 0 ? data : DUMMY_ACTIVITY
        setItems(rows.slice(0, limit))
        setLoading(false)
      })
  }, [limit])

  return { items, loading }
}
